import React from 'react';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { CHECKOUT_COPY } from 'lib/billing';
import { ABOVE_DRAWER_SX } from './sharedStyles';

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  busy: boolean;
  title: string;
  description: string;
  confirmLabel: string;
};

export function CancelConfirmModal({ open, onClose, onConfirm, busy, title, description, confirmLabel }: Props) {
  const KEEP = CHECKOUT_COPY.cancel.modal.keep;
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth sx={ABOVE_DRAWER_SX}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack spacing={1}>
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>
          {KEEP}
        </Button>
        <Button
          onClick={onConfirm}
          disabled={busy}
          variant="contained"
          color="error"
          startIcon={busy ? <CircularProgress size={16} color="inherit" /> : null}
        >
          {busy ? CHECKOUT_COPY.cancel.modal.busy : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
